import { Controller } from "@hotwired/stimulus"
import React from 'react'
import ReactDOM from 'react-dom/client'
import ConversationApp from '../react/conversations/ConversationApp'

// Connects to data-controller="conversation-react"
export default class extends Controller {
  static values = { conversationId: String }
  
  connect() {
    console.log("Conversation React controller connected")
    console.log("Conversation ID:", this.conversationIdValue)
    
    // Create React root and render the app
    this.root = ReactDOM.createRoot(this.element)
    this.root.render(<ConversationApp conversationId={this.conversationIdValue} />)
    console.log("React app mounted")
  }
  
  disconnect() {
    console.log("Conversation React controller disconnecting")
    // Clean up React when the controller disconnects
    if (this.root) {
      this.root.unmount()
      this.root = null
      console.log("React app unmounted")
    }
  }
}